import type {
  ApiNotification,
  UiNotification,
} from '../../schemas/notification.schema';

export function mapNotificationFromApi(api: ApiNotification): UiNotification {
  return {
    id: api.id,
    body: api.body,
    createdAt: api.createdAt,
    data: api.data,
    readAt: api.readAt,
    tenantId: api.tenantId,
    title: api.title,
    type: api.type,
    updatedAt: api.updatedAt,
    userId: api.userId,
  };
}
